<template>
	<div id="ordersModule">
		<order-list-component></order-list-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import axiosAction from '@/mixins/axiosAction.js'
import errors from '@/mixins/errors.js'

import OrderListComponent from '@/components/OrderListComponent.vue'

export default {
	name: 'OrdersModule',
	mixins: [mixin, axiosAction, errors],
	data() {
		return {
		}
	},
	components: {
		'order-list-component': OrderListComponent
	},
	computed: {
	},
	methods: {
		axiosResultLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'defaultFunction': this.defaultFunction(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')', this.$options.name); break;
			}
		},
		initModuleLocal() {
		}
	},
	mounted() {
		this.initModule(this.$options.name)
	},
}	
</script>

<style lang="scss"></style>
